import request from '@/router/axios';

const pre_fix = '/dotadmin/dotadmin/qc/';

export function getFlowInfo(id) {
  return request({
    url: pre_fix + id,
    method: 'get',
  });
}

export function qcConfigInfo(flowInfo) {
  return request({
    url: pre_fix + 'qcConfigInfo/' + flowInfo.orderId,
    method: 'get',
    params: flowInfo,
  });
}

export function listQC(data) {
  return request({
    url: pre_fix + 'listQC',
    method: 'get',
    params: data,
  });
}

// 质控人列表--新
export function pageSelectQc(data) {
  return request({
    url: '/dotadmin/manage/pageSelectQc',
    method: 'get',
    params: data,
  });
}

export function qcStart(flowInfo) {
  return request({
    url: pre_fix + 'start/' + flowInfo.flowId,
    method: 'post',
    params: flowInfo,
  });
}

// 多个任务一起开始
export function qcStarts(flowInfo) {
  return request({
    url: pre_fix + 'starts',
    method: 'post',
    data: flowInfo,
  });
}

export function addQc(flowInfo) {
  return request({
    url: pre_fix + 'addQc/' + flowInfo.flowId,
    method: 'post',
    // params: {qcIds: flowInfo.qcIds}
    params: flowInfo,
  });
}

// 多个任务一起添加质控人
export function configQcTaskByPm(flowInfo) {
  return request({
    url: pre_fix + 'configQcTaskByPm',
    method: 'post',
    // params: {qcIds: flowInfo.qcIds}
    data: flowInfo,
  });
}

export function configQcTaskByQc(flowInfo) {
  return request({
    url: pre_fix + 'configQcTaskByQc',
    method: 'post',
    // params: {qcIds: flowInfo.qcIds}
    data: flowInfo,
  });
}

// 多个任务一起添加质控人
export function updateQcTask(flowInfo) {
  return request({
    url: pre_fix + 'updateQcTask',
    method: 'post',
    data: flowInfo,
  });
}

// pm分配质控任务--字数验证
export function checkWordNumByPm(obj) {
  return request({
    url: pre_fix + 'checkWordNumByPm',
    method: 'post',
    params: obj,
  });
}

// 质控分配质控任务--字数验证
export function checkWordNumByQc(obj) {
  return request({
    url: pre_fix + 'checkWordNumByQc',
    method: 'post',
    params: obj,
  });
}

export function addQcMessage(flowInfo) {
  return request({
    url: pre_fix + 'addQcMessage',
    method: 'post',
    data: flowInfo,
  });
}

export function qcTermList(orderId) {
  return request({
    url: pre_fix + 'qcTermList/' + orderId,
    method: 'get',
  });
}

export function pageTermList(flowInfo) {
  return request({
    url: pre_fix + 'pageTermList',
    method: 'post',
    params: flowInfo,
  });
}

export function qcAuditTask(flowInfo) {
  return request({
    url: pre_fix + 'qcAuditTask',
    method: 'post',
    data: flowInfo,
  });
}

export function textList(obj) {
  return request({
    url: pre_fix + 'textList',
    method: 'post',
    params: obj,
  });
}

// 添加术语和更新属于前的校验
export function qcTermCheckBeforeAdd(flowInfo) {
  return request({
    url: pre_fix + 'qcTermAdd',
    method: 'post',
    data: flowInfo,
  });
}

export function addTerm(flowInfo) {
  return request({
    url: pre_fix + 'addTerm',
    method: 'post',
    data: flowInfo,
  });
}

export function updateTerm(flowInfo) {
  return request({
    url: pre_fix + 'updateTerm',
    method: 'post',
    data: flowInfo,
  });
}

export function qcTermDelete(flowInfo) {
  return request({
    url: pre_fix + 'qcTermDelete',
    method: 'post',
    data: flowInfo,
  });
}

export function deleteTerm(flowInfo) {
  return request({
    url: pre_fix + 'deleteTerm',
    method: 'post',
    data: flowInfo,
  });
}

export function queryQc(flowId) {
  return request({
    url: pre_fix + 'queryQc/' + flowId,
    method: 'post',
  });
}

export function finish(flowId) {
  return request({
    url: pre_fix + 'finish/' + flowId,
    method: 'post',
  });
}

export function getTJInfo(flowInfo) {
  return request({
    url: pre_fix + 'tj',
    method: 'get',
    params: flowInfo,
  });
}

export function qcTaskStatistics(orderId) {
  return request({
    url: pre_fix + 'qcTaskStatistics',
    method: 'get',
    params: orderId,
  });
}

export function submitMainQcTask(flowInfo) {
  return request({
    url: pre_fix + 'submitMainQcTask',
    method: 'post',
    params: flowInfo,
  });
}

export function submitSubQcTask(flowInfo) {
  return request({
    url: pre_fix + 'submitSubQcTask',
    method: 'post',
    params: flowInfo,
  });
}

export function cancelQcTask(flowInfo) {
  return request({
    url: pre_fix + 'cancelQcTask',
    method: 'post',
    params: flowInfo,
  });
}

export function qcList(flowInfo) {
  return request({
    url: pre_fix + 'qcList',
    method: 'post',
    params: flowInfo,
  });
}

export function checkSubmitSubTask(flowInfo) {
  return request({
    url: pre_fix + 'checkSubmitSubTask',
    method: 'post',
    params: flowInfo,
  });
}

export function checkSubmitMainTask(flowInfo) {
  return request({
    url: pre_fix + 'checkSubmitMainTask',
    method: 'post',
    params: flowInfo,
  });
}

export function checkfinishQcFlowByPm(flowInfo) {
  return request({
    url: pre_fix + 'checkfinishQcFlowByPm',
    method: 'post',
    params: flowInfo,
  });
}

export function subTaskList(flowInfo) {
  return request({
    url: pre_fix + 'subTaskList',
    method: 'post',
    params: flowInfo,
  });
}

export function seleteById(id) {
  return request({
    url: pre_fix + 'seleteById',
    method: 'get',
    params: id,
  });
}

export function checkQcSingleOrMulti(flowInfo) {
  return request({
    url: pre_fix + 'checkQcSingleOrMulti',
    method: 'post',
    params: flowInfo,
  });
}

export function saveQcTaskIdKey(flowInfo) {
  return request({
    url: pre_fix + 'saveQcTaskIdKey',
    method: 'post',
    params: flowInfo,
  });
}

export function checkQcControlTime(flowInfo) {
  return request({
    url: pre_fix + 'checkQcControlTime',
    method: 'post',
    params: flowInfo,
  });
}

export function saveQcControlTime(flowInfo) {
  return request({
    url: pre_fix + 'saveQcControlTime',
    method: 'post',
    params: flowInfo,
  });
}
export function insertTrAbilityQc(obj) {
  return request({
    url: pre_fix + 'insertTrAbilityQc',
    method: 'post',
    data: obj,
  });
}
export function checkTrAbilityQc(obj) {
  return request({
    url: pre_fix + 'checkTrAbilityQc',
    method: 'post',
    data: obj,
  });
}
export function deleteTrAbilityQc(obj) {
  return request({
    url: pre_fix + 'deleteTrAbilityQc',
    method: 'post',
    data: obj,
  });
}

export function readNoMissBatch(obj) {
  return request({
    url: pre_fix + 'readNoMissBatch',
    method: 'post',
    data: obj,
  });
}

export function reportAuditorSentCount(obj) {
  return request({
    url: pre_fix + 'reportAuditorSentCount',
    method: 'get',
    params: obj,
  });
}

export function reportSent(obj) {
  return request({
    url: pre_fix + 'reportSent',
    method: 'get',
    params: obj,
  });
}

//获取重新分配数据
export function assignQcInfo(obj) {
  return request({
    url: pre_fix + 'assignQcInfo',
    method: 'get',
    params: obj,
  });
}

// pm修改质控任务
export function reSetQcConfigByPm(obj) {
  return request({
    url: pre_fix + 'reSetQcConfigByPm',
    method: 'post',
    data: obj,
  });
}

// 主质控修改质控任务
export function reSetQcConfigByQc(obj) {
  return request({
    url: pre_fix + 'reSetQcConfigByQc',
    method: 'post',
    data: obj,
  });
}

// 剩余未处理句子数
export function incompleteSentCount(obj) {
  return request({
    url: pre_fix + 'incompleteSentCount',
    method: 'post',
    params: obj,
  });
}

// pm分配质控个数
export function configQcTaskNumByPm(obj) {
  return request({
    url: pre_fix + 'configQcTaskNumByPm',
    method: 'post',
    data: obj,
  });
}

// qc分配质控个数
export function configQcTaskNumByQc(obj) {
  return request({
    url: pre_fix + 'configQcTaskNumByQc',
    method: 'post',
    data: obj,
  });
}

// pm配置质控价格
export function configQcTaskAmountByPm(obj) {
  return request({
    url: '/dotadmin/dotadmin/qc/configQcTaskAmountByPm',
    method: 'post',
    data: obj,
  });
}

// qc配置质控价格
export function configQcTaskAmountByQc(obj) {
  return request({
    url: pre_fix + 'configQcTaskAmountByQc',
    method: 'post',
    data: obj,
  });
}

// pm修改分配字数
export function updateQcTaskWordByPm(obj) {
  return request({
    url: '/dotadmin/dotadmin/qc/updateQcTaskWordByPmFlag',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: obj,
  });
}

export function getDotOrderWordTj(param) {
  return request({
    url: '/dotadmin/dotadmin/qc/getDotOrderWordTj',
    method: 'get',
    params: param,
  });
}

// 审核人列表
export function queryQcTrStat(param) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/queryQcTrStat',
    method: 'get',
    params: param,
  });
}

// 新增质控任务
export function saveQcTaskFlag(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/saveQcTaskFlag',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

// 删除质控任务
export function deleteQcTaskFlag(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/deleteQcTaskFlag',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

// 计算金额
export function getAmountByTaskId(obj) {
  return request({
    url: '/dotadmin/dotadmin/qc/getAmountByTaskId',
    method: 'post',
    data: obj,
  });
}

// 查询待分配字数
export function getUndealtWordNum(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/getUndealtWordNum',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

// 查询质控总金额
export function getTotalAmount(param) {
  return request({
    url: '/dotadmin/dotadmin/qc/getTotalAmount',
    method: 'get',
    params: param,
  });
}

// 查询例句和直出折扣
export function getDiscount(param) {
  return request({
    url: '/dotadmin/dotadmin/qc/getDiscount',
    method: 'get',
    params: param,
  });
}

// 质控术语导出
export function qcTermExport(obj) {
  return request({
    url: '/dotadmin/dotadmin/qc/qcTermExport',
    method: 'post',
    responseType: 'blob',
    data: obj,
  });
}

// 句子合并
export function mergeSent(data) {
  return request({
    url: '/dotadmin/dotadmin/merge/mergeSent',
    method: 'post',
    data: data,
  });
}

// 获取合并前的句子
export function mergeSentList(data) {
  return request({
    url: '/dotadmin/dotadmin/merge/mergeSentList',
    method: 'get',
    params: data,
  });
}

// 取消句子合并
export function cancelMergeSent(data) {
  return request({
    url: '/dotadmin/dotadmin/merge/cancelMergeSent',
    method: 'post',
    data: data,
  });
}

// 查询质控接单配置
export function getQcWorkConfig(data) {
  return request({
    url: '/dotadmin/manage/getQcWorkConfig',
    method: 'get',
    params: data,
  });
}

// 查询质控账号信息
export function getQcInfoByStaffId(data) {
  return request({
    url: '/dotadmin/manage/getQcInfoByStaffId',
    method: 'get',
    params: data,
  });
}

// 质控接单配置和修改
export function saveOrupdateWorkConfig(data) {
  return request({
    url: '/dotadmin/manage/saveOrupdateWorkConfig',
    method: 'post',
    data: data,
  });
}

// 系统派单
export function dispatchQc(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/disPatchQc',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

// 改派
export function reAssignQcTask(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/reAssignQcTask',
    method: 'post',
    data: data,
  });
}

// 质控配置操作日志
export function qcTaskLogList(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/qcTaskLogList',
    method: 'get',
    params: data,
  });
}

// 质控批量替换修改提交
export function qcUpdateTextBatch(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/qcUpdateTextBatch',
    method: 'post',
    data: data,
  });
}

// 项目术语列表
export function orderTermPage(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/orderTermPage',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

// 删除项目术语列表
export function delOrderTerm(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/delOrderTerm',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}
// 批量导入术语
export function addTermBatch(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/addTermBatch',
    method: 'post',
    data: data,
  });
}
// 打回子任务
export function returnSubQcTask(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/returnSubQcTask',
    method: 'post',
    data: data,
  });
}
